package com.evoapps.evoshift.util

import androidx.compose.runtime.Composable
import kotlinx.browser.document
import kotlinx.browser.window

/**
 * Compose resources on the web read `navigator.language(s)`; app.html makes both return
 * `window.__evoshiftLang` when it is set (the language from ?lang= or picked in the app), the
 * browser's otherwise.
 */
actual fun applyPlatformLanguage(language: String?) {
    window.asDynamic().__evoshiftLang = language
    document.documentElement?.setAttribute("lang", language ?: window.navigator.language.substringBefore('-'))
}

@Composable
actual fun KeepPlatformLanguage(language: String?) = Unit
